// @ts-nocheck
import GenericMobileRenderWrestlerWhenNumberInSide from '../GenericUtilitiesComponents/GenericMobileRenderWrestlerWhenNumberInSide';

function MobileRenderWrestlerWhenOneInSide({ wrestler, side }) {
    return (
        <GenericMobileRenderWrestlerWhenNumberInSide
         wrestler={wrestler}
         side={side}
         heightCardPercentage='100%'
         heightPixelAvatar='50px'
         widthPixelAvatar='50px'
         flexDirectionSpaceWrestler='column'
         justifyContentSpaceWrestler='center'
         rowGapSpaceWrestler='5px'
         widthNameWrestler='100%'
        />
    )
}

export default MobileRenderWrestlerWhenOneInSide;